<template>
  <div class="rule-wrap">
    <div class="rule-enter" @click="show">
      活动规则
      <img src="../../assets/images/arrow.png" alt="">
    </div>
    <modal :showstate="status" :showTitle="true" @close="hide">
      <div class="rule-tit" slot="tit">活动规则</div>
      <div class="rule-content" slot="text">{{ruleDes}}</div>
    </modal>
  </div>
</template>
<script>
import modal from '../modal/modal';

export default {
  components: {
    modal,
  },
  props: ['ruleDes'],
  data() {
    return {
      status: false,
    };
  },
  methods: {
    show() {
      this.status = true;
    },
    hide() {
      this.status = false;
    },
  },
};
</script>
<style lang="stylus">
.rule-wrap{
  .rule-enter{
    position: absolute;
    right:0;
    top:110.2vw;
    width:72px;
    height: 24px;
    text-align: center;
    display: flex;
    align-items: center;
    font-size: 12px;
    background: rgba(255,255,255,.2);
    border-radius: 15px 0 0 15px;
    justify-content: center;
  }
  .rule-tit{
    padding-top: 25px;
    font-size: 18px;
    color:#000;
  }
  .rule-content{
    max-height: 250px;
    overflow-y: auto;
    white-space:pre-wrap;
    text-align: left;
    width:90%;
    margin:auto;
    margin-top: 25px;
    font-size: 14px;
    color: #46494D;
  }
}
</style>
